import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";

import { environment } from "@env/environment";
// import { MetaService } from "@ngx-meta/core";
import { SharedService } from "@services/shared.service";

import * as metacontent from "../metacontent";
import { CommonService } from "./common.service";

@Injectable({
  providedIn: "root",
})
export class YTBSEOService {
  countryName: string;
  flightName: string;
  phoneNumber: string;
  copyrightYear: string;
  searchParams: any;

  constructor(
    private meta: Meta,
    private shared: SharedService,
    private common: CommonService,
    private title: Title,
    private activatedRoute: ActivatedRoute,
    private readonly metaService: Meta,
    @Inject(DOCUMENT) private dom
  ) {
    this.shared.searchRequestParam$.subscribe((params) => {
      if (params != null && params != undefined) {
        this.searchParams = params;
      }
    });
  }

  deleteMetaTags() {
    const desc = this.meta.getTags("name=description");
    for (let metaTag of desc) {
      this.meta.removeTagElement(metaTag);
    }

    const keywords = this.meta.getTags("name=keywords");
    for (let metaTag of keywords) {
      this.meta.removeTagElement(metaTag);
    }
  }

  updateMetaTags(metaType: string, replaceKeywords: any, pageName: string) {
    let page: any[] = metacontent[pageName];
    let metaObj: Array<any>;
    let contentString = "";
    let replace_string_array = [];
    if (metaType == "desc") {
      // for meta description
      if (page != null && page != undefined) {
        metaObj = page.filter((x) => x.name == "description");
        if (replaceKeywords != null) {
          let keys = Object.keys(replaceKeywords.replaceKeywords);
          keys.forEach((key) => {
            replace_string_array.push("${" + key + "}");
          });

          if (keys.length > 1) {
            contentString = metaObj[0].content
              .replace(
                replace_string_array[0],
                replaceKeywords.replaceKeywords[keys[0]]
              )
              .replace(
                replace_string_array[1],
                replaceKeywords.replaceKeywords[keys[1]]
              );
          } else {
            contentString = metaObj[0].content.replace(
              replace_string_array[0],
              replaceKeywords.replaceKeywords[keys[0]]
            );
          }

          // this.metaService

          // this.meta.addTag({ name: "description", content: contentString });
          // this.meta.addTag({ property: "og:description", content: contentString });
          // this.meta.addTag({ name: "twitter:description", content: contentString });
        }
      }
    } else {
      // for keywords
      if (page != null && page != undefined) {
        metaObj = page.filter((x) => x.name == "keywords");
        if (replaceKeywords != null) {
          if (replaceKeywords.replaceKeywords.country != undefined) {
            let country = replaceKeywords.replaceKeywords.country;
            let contentString = metaObj[0].content.replace(
              "${country}",
              country
            );
            // this.meta.addTag({ name: "keywords", content: contentString });
          }
        } else {
          metaObj = page.filter((x) => x.name == "keywords");
          // this.meta.addTag({ name: "keywords", content: metaObj[0].content });
        }
      }
    }
  }

  async setDynamicTitle(route, keyword: string | {} = "") {
    try {
      let country: string | {};
      let name: string | {};
      let child, title: string;
      console.log(child, title, route);
      this.addMetaTags(route, keyword);
      switch (route) {
        case "/reschedule":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          break;
        case "/makeExternalPayment":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          break;

        case "/activity-details":
          child = this.activatedRoute.firstChild;
          title = child.snapshot.data["title"].replace("${name}", country);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });

          break;

        case "/activity-voucher":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });

          break;

        case "/activity-payment":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });

          break;

        case "/activity-traveller-info":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });

          break;

        case "/voucher/unconfirmed":
        case "/voucher/success":
        case "/voucher/success":
          title = "Your Flight Booking is Success. Happy Journey";
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;
        case "/voucher":
          title = "Your Flight Booking is Success. Happy Journey";
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/pending-voucher/unconfirmed":
          title = "Your Flight Booking is Pending. Contact support team";
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/flight-service":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }

          break;

        case "/error":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });

          break;

        case "/feedback":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          console.log("nagaraju ", title);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/SigninUser":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/SignupUser":
        case "/SignupAgent":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/change-password":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/print-itinerary":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/covid-policy":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/cancellation":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/terms-and-conditions":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/our-services":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/about-us":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/my-account":
          title = "Your Travel Booking- View Profile";
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          // if (child && child.snapshot &&  child.snapshot.data && child.snapshot.data["image"]) {
          //   this.setMetaImageDesc(child.snapshot.data["image"]);
          // } else {
          this.setMetaImageDesc("assets/ytb-images/yourtravelbooking-logo.png");
          // }
          break;

        case "/manageorganization":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/createorganizationuser":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/createorganization":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/createbranch":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/refund-policy":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/privacy-policy":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/chatwithus":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/socialmedia":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/voucher":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/fare-rules":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/help":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/cookiepolicy":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/contactus":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/car-payments":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          // this.meta.updateTag({name:"twitter:title",content:title});
          // this.meta.updateTag({name:"og:title",content:title});

          break;

        case "/sitemaintainance":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });

          break;

        case "/payments":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });

          break;

        case "/unsubscribe":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });

          break;

        case "/Email-Confirmation-Check":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
          // this.meta.addTag({ name: "twitter:title", content: title });
          // this.meta.addTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/search/flights":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(
            "${from} To ${to} Flight Results | YourTravelBooking",
            keyword,
            true
          );
          this.title.setTitle(title);
          // this.meta.addTag({ name: "twitter:title", content: title });
          // this.meta.addTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/flight-details/preview":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(
            "${detailsText} | YourTravelBooking",
            keyword
          );
          this.title.setTitle(title);
          // this.meta.addTag({ name: "twitter:title", content: title });
          // this.meta.addTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/book":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          console.log(title);
          this.title.setTitle(title);
          // this.meta.addTag({ name: "twitter:title", content: title });
          // this.meta.addTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/book/flight":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          console.log(title);
          this.title.setTitle(title);
          // this.meta.addTag({ name: "twitter:title", content: title });
          // this.meta.addTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/hotel-search":
          child = this.activatedRoute.firstChild;
          country = keyword;
          title = child.snapshot.data["title"].replace("${country}", country);
          this.title.setTitle(title);
          // this.meta.addTag({ name: "twitter:title", content: title });
          // this.meta.addTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          // this.meta.updateTag({name:"twitter:title",content:title});
          // this.meta.updateTag({name:"og:title",content:title});

          break;

        case "/hotel-details":
          child = this.activatedRoute.firstChild;
          name = keyword;
          title = child.snapshot.data["title"].replace("${name}", name);
          this.title.setTitle(title);
          // this.meta.addTag({ name: "twitter:title", content: title });
          // this.meta.addTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          // this.meta.updateTag({name:"twitter:title",content:title});
          // this.meta.updateTag({name:"og:title",content:title});

          break;

        case "/car-details":
          child = this.activatedRoute.firstChild;
          name = keyword;
          title = child.snapshot.data["title"].replace("${name}", name);

          // title =    eval("`" + child.snapshot.data["title"] + "`");
          this.title.setTitle(title);
          // this.meta.addTag({ name: "twitter:title", content: title });
          // this.meta.addTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);

          break;

        case "/car-list":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
          // this.meta.addTag({ name: "twitter:title", content: title });
          // this.meta.addTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);

          break;

        case "/activity-search":
          // child = this.activatedRoute.firstChild;
          // country = keyword;
          // title = child.snapshot.data["title"].replace('${country}', country);
          // this.title.setTitle(title);
          // this.metaService.setTitle(title, true);
          // this.metaService.setTag("twitter:title", title);
          // this.metaService.setTag("og:title", title);
          console.log(keyword);
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          console.log(title);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);

          break;

        case "/lp/hotels":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
          // // this.meta.updateTag({ name: "twitter:title", content: title });
          // // this.meta.updateTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/lp/cars":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
          // // this.meta.updateTag({ name: "twitter:title", content: title });
          // // this.meta.updateTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/lp/flights":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
          // // this.meta.updateTag({ name: "twitter:title", content: title });
          // // this.meta.updateTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/lp/activities":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
          // // this.meta.updateTag({ name: "twitter:title", content: title });
          // // this.meta.updateTag({ property: "og:title", content: title });

        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);

          break;

        case "/coupons":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          console.log(child, " At Coupons Dynamic Title  ", title);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/couponsDownload":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
          console.log(child, " At Coupons Download Dynamic Title  ", title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/corporatetravelplanning":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        case "/worldwideairticketing":
          child = this.activatedRoute.firstChild;
          title = await this.replaceTitle(child, keyword);
          this.title.setTitle(title);
        //  this.metaService.setTitle(title, true);
        //  this.metaService.setTag("twitter:title", title);
        //  this.metaService.setTag("og:title", title);
          this.meta.updateTag({ name: "twitter:title", content: title });
          this.meta.updateTag({ name: "og:title", content: title });
          if (
            child &&
            child.snapshot &&
            child.snapshot.data &&
            child.snapshot.data["image"]
          ) {
            this.setMetaImageDesc(child.snapshot.data["image"]);
          } else {
            this.setMetaImageDesc(
              "assets/ytb-images/yourtravelbooking-logo.png"
            );
          }
          break;

        default:
          this.title.setTitle(
            "Online Flight Tickets Booking at Lowest Airfare – YourTravelBooking"
          );
        //  this.metaService.setTitle(
          //   "Online Flight Tickets Booking at Lowest Airfare – YourTravelBooking",
          //   true
          // );
        //  this.metaService.setTag(
          //   "twitter:title",
          //   "Online Flight Tickets Booking at Lowest Airfare – YourTravelBooking"
          // );
        //  this.metaService.setTag(
          //   "og:title",
          //   "Online Flight Tickets Booking at Lowest Airfare – YourTravelBooking"
          // );
          this.addMetaTags("/flight");
          this.setMetaImageDesc("assets/ytb-images/yourtravelbooking-logo.png");

          // this.meta.updateTag({name:"twitter:title",content:"Online Flight Tickets Booking at Lowest Airfare – YourTravelBooking"});
          // this.meta.updateTag({name:"og:title",content:"Online Flight Tickets Booking at Lowest Airfare – YourTravelBooking"});
          break;
        // default: "";
      }
    } catch (err) {
      this.common.logError({
        loglevel: "Info",
        message: err,
      });
      console.log(err, "  nagarajuu 1314");
    }
  }

  addMetaTags(url, replaceKeyWord: string | {} = "") {
    try {
      let page: any[];
      // this.deleteMetaTags();

      switch (url) {
        case "/":
          page = metacontent.Homepage;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/unsubscribe":
          page = metacontent.EmailUnSubscribe;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/Email-Confirmation-Check":
          page = metacontent.EmailValidation;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/search/flights":
          page = metacontent.FlightSearch;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord, true);
          break;

        case "/flight-details/preview":
          page = metacontent.FlightDetails;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord, true);
          break;

        case "/book/flight":
          page = metacontent.FlightsBook;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;
        case "/book":
          page = metacontent.FlightsBook;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;
        case "/voucher":
          page = metacontent.FlightVoucher;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord, true);
          break;

        case "/voucher/unconfirmed":
        case "/voucher/success":
          page = metacontent.FlightVoucher;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord, true);
          break;

        case "/pending-voucher/unconfirmed":
          page = metacontent.FlightVoucher;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord, true);
          break;

        case "/hotel-search":
          page = metacontent.HotelSearch;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/hotel-details":
          page = metacontent.HotelDetails;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/hotel-travel-info":
          page = metacontent.HotelTravellInfo;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/hotel-Payment":
          page = metacontent.HotelPayment;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/hotel-voucher":
          page = metacontent.HotelVoucher;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/car-list":
          page = metacontent.CarSearch;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/car-details":
          page = metacontent.CarDetails;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);

          break;

        case "/car-payment-success":
          page = metacontent.CarPayment;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/error":
          page = metacontent.ErrorPage;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;
        case "/feedback":
          page = metacontent.Feedback;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/terms-and-conditions":
          page = metacontent.TermsAndConditions;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/refund-policy":
          page = metacontent.RefundPolicy;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/privacy-policy":
          page = metacontent.PrivacyPolicy;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/covid-policy":
          page = metacontent.CovidPolicy;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/cancellation":
          page = metacontent.CancellationPolicy;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/about-us":
          page = metacontent.AboutUs;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/book/flight":
          page = metacontent.FlightsBook;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/print-itinerary":
          page = metacontent.PrintItinerary;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/SignupUser":
        case "/SignupAgent":
          page = metacontent.SignUp;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/SigninUser":
          page = metacontent.Login;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/change-password":
          page = metacontent.ChangePassword;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/my-account":
          page = metacontent.Profile;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord, true);
          break;

        case "/createbranch":
          page = metacontent.ActivityTravellInfo;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/createorganization":
          page = metacontent.ActivityPayment;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/createorganizationuser":
          page = metacontent.WorldWideAirTicketingPage;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/manageorganization":
          page = metacontent.CorporateTravelPlanningPage;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/our-services":
          page = metacontent.Services;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/flight-service":
          page = metacontent.FlightService;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/coupons":
          page = metacontent.CouponsInformationPage;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/couponsDownload":
          page = metacontent.CouponsInformationPage;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/corporatetravelplanning":
          page = metacontent.Services;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/worldwideairticketing":
          page = metacontent.WorldWideAirTicketingPage;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);

          break;

        case "/help":
          page = metacontent.GeneralInquiry;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/cookiepolicy":
          page = metacontent.CookiePolicy;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/chatwithus":
          page = metacontent.ChatUs;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/socialmedia":
          page = metacontent.SocialNetworking;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/contactus":
          page = metacontent.ContactUs;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/flight":
          page = metacontent.Flights;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/hotel":
          page = metacontent.Hotels;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/car":
          page = metacontent.Cars;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/activities":
          page = metacontent.Activities;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/activity-search":
          page = metacontent.ActivitySearch;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/activity-details":
          page = metacontent.ActivityDetails;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/reschedule":
          page = metacontent.FlightScheduleChange;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/makeExternalPayment":
          page = metacontent.FlightScheduleChange;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/activity-traveller-info":
          page = metacontent.ActivityTravellInfo;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/activity-payment":
          page = metacontent.ActivityPayment;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        case "/activity-voucher":
          page = metacontent.ActivityVoucher;
          this.setMetaDescriptionKeywords(page, url, replaceKeyWord);
          break;

        default:
          "";
      }
    } catch (err) {
      this.common.logError({
        loglevel: "Info",
        message: err,
      });
      console.log(err, "  nagarajuu 1623");
    }
  }

  setOrgContactMetaDtls(orgcontact: any[]) {
    let phone = orgcontact.find((x) => x.contactTypeCode == "PH");
    let email = orgcontact.find((x) => x.contactTypeCode == "EL");

    let contactMetaInfo = [
      { name: "og:phone_number", content: phone ? phone.contactValue : "" },
      { name: "og:email", content: email ? email.contactValue : "" },
    ];
    // this.meta.addTags(contactMetaInfo, true);
  }

  setMetaImageDesc(image) {
  //  this.metaService.setTag("og:image", image);
  //  this.metaService.setTag("twitter:image:src", image);
  //  this.metaService.setTag("og:image:width", "256");
  //  this.metaService.setTag("og:image:height", "256");
  //  this.metaService.setTag("og:image:secure_url", image);
  //  this.metaService.setTag("og:image:secure_url:width", "256");
  //  this.metaService.setTag("og:image:secure_url:height", "256");
  }

  async setMetaDescriptionKeywords(
    page,
    url,
    keyToReplace: string | {} = "",
    directString: boolean = false
  ) {
    try {
      let description = page.find((x) => x.name == "description").content;
      let newDescription = description;

      if (description.includes("${")) {
        newDescription = await this.replaceTitle(
          description,
          keyToReplace,
          directString
        );
      }
      // this.metaService.setTag(
      //   "og:url",
      //   "" + url
      // );
    //  this.metaService.setTag("og:description", newDescription);
    //  this.metaService.setTag("description", newDescription);
    //  this.metaService.setTag("twitter:description", newDescription);
      this.meta.updateTag({ name: "og:description", content: newDescription });
      this.meta.updateTag({ name: "description", content: newDescription });
      this.meta.updateTag({
        name: "twitter:description",
        content: newDescription,
      });

      this.createCanonicalURL(url);
    } catch (err) {
      this.common.logError({
        loglevel: "Info",
        message: err,
      });
      console.log(err, "  nagarajuu 1685");
    }
  }

  createCanonicalURL(url: string) {
    const canonical = this.dom.querySelector("link[rel^='canonical']");
    if (canonical) this.dom.head.removeChild(canonical);
    let link: HTMLLinkElement = this.dom.createElement("link");
    link.setAttribute("rel", "canonical");
    this.dom.head.appendChild(link);
    link.setAttribute("href", `${url}`);
  }

  async replaceTitle(child, keyword, defaultString: boolean = false) {
    try {
      console.log(child, keyword);
      let title: string;
      let keys: string[] = [];
      let replace_string_array: string[] = [];
      keys = Object.keys(keyword);
      keys.forEach((key) => {
        replace_string_array.push("${" + key + "}");
      });
      let newTitle;
      if (defaultString) {
        newTitle = child;
      } else {
        if (child && child?.snapshot && child?.snapshot?.data["title"]) {
          newTitle = child.snapshot.data["title"];
        } else {
          newTitle = child;
        }
      }

      if (keys.length > 1) {
        title = newTitle
          .replace(replace_string_array[0], keyword[keys[0]])
          .replace(replace_string_array[1], keyword[keys[1]]);
      } else {
        title = newTitle.replace(replace_string_array[0], keyword[keys[0]]);
      }

      return title;
    } catch (err) {
      this.common.logError({
        loglevel: "Info",
        message: err,
      });
      console.log(err, "  nagarajuu 1733");
    }
  }

  setOgUrl(url) {
    if (!environment.production) {
      // // this.meta.updateTag({ property: 'og:url', content: 'http://yourtravelbooking.com' + url });
    } else {
      // // this.meta.updateTag({ property: 'og:url', content: 'http://db.yourtravelbooking.com:4000' + url });
    }
  }
}
